







































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import DataPenunjang from "@/services/DataPenunjang";
import moment from "moment";
import LabTrenGrafikDialog from "@/components/pemeriksaan/tabs/penunjang/LabTrenGrafikDialog.vue";
import {
  OpsiPemeriksaan,
  gabungOpsi,
  kunciPemeriksaan,
  opsiPemeriksaan
} from "@/utils/labTren";

interface RiwayatLabItem {
  test_id: string;
  nama_test: string;
  hasil: string;
  satuan: string;
  nilai_normal: string;
  flag: string;
}

interface RiwayatLabSample {
  lis_sampel: string;
  no_order: string;
  tgl_order: string;
  acc_date: string;
  acc_by: string;
  rm: string;
  nama: string;
  register: string;
  unit_kode: string;
  unit_nama: string;
  dokter: string | null;
  jenis: string;
  jenis_label: string;
  jumlah_abnormal: number;
  items: RiwayatLabItem[];
}

@Component({ components: { LabTrenGrafikDialog } })
export default class CardRiwayatHasilLab extends Vue {
  @Prop({ required: true }) rm!: string;

  loading = false;
  rawList: RiwayatLabSample[] = [];
  expanded: RiwayatLabSample[] = [];
  nomorPermintaan = 0;
  dialogGrafik = false;

  today = moment().format("YYYY-MM-DD");
  tglMasuk = "";
  tglKeluar = "";
  menuMasuk = false;
  menuKeluar = false;

  filterPemeriksaan: string[] = [];
  opsiTerkumpul: OpsiPemeriksaan[] = [];
  hanyaAbnormal = false;
  filterJenis = "semua";

  jenisOptions = [
    { text: "Semua Unit", value: "semua" },
    { text: "Rawat Jalan", value: "ralan" },
    { text: "Rawat Inap", value: "ranap" },
    { text: "IGD", value: "igd" },
    { text: "Lainnya (penunjang/IBS/HD)", value: "unknown" }
  ];

  headers = [
    { text: "Tgl Hasil", value: "tgl", width: "120" },
    { text: "Jenis", value: "jenis", width: "120", sortable: false },
    { text: "Unit", value: "unit_nama" },
    { text: "Acc Oleh", value: "acc_by" },
    { text: "Ringkasan", value: "ringkas", sortable: false },
    { text: "", value: "data-table-expand" }
  ];

  @Watch("rm")
  onRmChange() {
    this.filterPemeriksaan = [];
    this.opsiTerkumpul = [];
    this.dialogGrafik = false;
    this.rawList = [];
    this.expanded = [];
    this.reload();
  }

  created() {
    this.reload();
  }

  reload() {
    if (!this.rm) return;
    const nomor = ++this.nomorPermintaan;
    this.loading = true;
    DataPenunjang.getDataRiwayatLab(this.rm, this.tglMasuk, this.tglKeluar)
      .then((res: any) => {
        if (nomor !== this.nomorPermintaan) return;
        this.rawList = res && Array.isArray(res.data) ? res.data : [];
        this.opsiTerkumpul = gabungOpsi(
          opsiPemeriksaan(this.rawList),
          this.opsiTerkumpul
        );
        this.expanded =
          this.filteredList.length > 0 ? [this.filteredList[0]] : [];
      })
      .finally(() => {
        if (nomor === this.nomorPermintaan) this.loading = false;
      });
  }

  applyFilterTanggal() {
    this.reload();
  }

  get pemeriksaanOptions(): OpsiPemeriksaan[] {
    const pilihan = this.kunciFilterPemeriksaan;
    return gabungOpsi(
      opsiPemeriksaan(this.rawList),
      this.opsiTerkumpul.filter(o => pilihan[o.value])
    );
  }

  get kunciFilterPemeriksaan(): { [kunci: string]: boolean } {
    const peta: { [kunci: string]: boolean } = {};
    (this.filterPemeriksaan || []).forEach(k => {
      peta[k] = true;
    });
    return peta;
  }

  hapusFilterPemeriksaan(kunci: string) {
    this.filterPemeriksaan = this.filterPemeriksaan.filter(k => k !== kunci);
  }

  get filteredList(): RiwayatLabSample[] {
    return this.rawList.filter(sample => {
      if (this.filterJenis !== "semua" && sample.jenis !== this.filterJenis) {
        return false;
      }
      return this.visibleItems(sample).length > 0;
    });
  }

  visibleItems(sample: RiwayatLabSample): RiwayatLabItem[] {
    const items = sample.items || [];
    const pilihan = this.kunciFilterPemeriksaan;
    const adaPilihan = (this.filterPemeriksaan || []).length > 0;
    return items.filter(i => {
      if (this.hanyaAbnormal && !this.isAbnormal(i.flag)) return false;
      if (adaPilihan && !pilihan[kunciPemeriksaan(i.nama_test)]) {
        return false;
      }
      return true;
    });
  }

  isAbnormal(flag: string): boolean {
    return ["H", "L", "C"].includes(flag);
  }

  countAbnormal(items: RiwayatLabItem[]): number {
    return items.filter(i => this.isAbnormal(i.flag)).length;
  }

  jenisColor(jenis: string): string {
    switch (jenis) {
      case "igd":
        return "red darken-2";
      case "ranap":
        return "indigo darken-1";
      case "ralan":
        return "teal darken-1";
      default:
        return "blue-grey darken-1";
    }
  }

  formatTgl(val: string): string {
    if (!val) return "-";
    const m = moment(val);
    return m.isValid() ? m.format("DD-MM-YYYY HH:mm") : val;
  }

  get keteranganFilter(): string {
    const parts: string[] = [];
    if (this.tglMasuk || this.tglKeluar) {
      parts.push(
        `Periode ${this.tglMasuk || "awal"} s/d ${this.tglKeluar || "kini"}`
      );
    }
    const pilihan = this.filterPemeriksaan || [];
    if (pilihan.length) {
      const nama = pilihan.map(k => {
        const opsi = this.pemeriksaanOptions.find(o => o.value === k);
        return opsi ? opsi.text : k;
      });
      parts.push(
        `pemeriksaan ${nama.slice(0, 3).join(", ")}${
          nama.length > 3 ? ` +${nama.length - 3} lainnya` : ""
        }`
      );
    }
    if (this.hanyaAbnormal) parts.push("hanya abnormal");
    if (this.filterJenis !== "semua") {
      const opt = this.jenisOptions.find(o => o.value === this.filterJenis);
      if (opt) parts.push(opt.text);
    }
    return parts.length ? "Filter: " + parts.join(" · ") : "Semua hasil lab pasien";
  }

  expandRow(item: RiwayatLabSample) {
    const idx = this.expanded.findIndex(
      e => e.lis_sampel === item.lis_sampel
    );
    if (idx >= 0) {
      this.expanded.splice(idx, 1);
    } else {
      this.expanded.push(item);
    }
  }
}
